export default "__VITE_ASSET__taOfY4sump2Q$c6Oo$$7nA__"